/**
 * Language Switcher Component
 * Allows users to switch between English and Indonesian
 */

import { useLanguage } from '@/contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Dropdown } from '@/components/common/Dropdown';

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();

  const languages = [
    { value: 'en', label: t('language.en'), icon: Globe },
    { value: 'id', label: t('language.id'), icon: Globe },
  ];

  const currentLanguage = languages.find((lang) => lang.value === language) || languages[0];

  return (
    <Dropdown
      options={languages}
      value={language}
      onChange={setLanguage}
      triggerIcon={Globe}
      triggerLabel={currentLanguage.value.toUpperCase()}
      ariaLabel="Select language"
    />
  );
}
